import { useState, useEffect } from 'react';

const API = process.env.REACT_APP_API_URL;

// Lädt einen Rechtstext (agb / datenschutz) mit lokalem Cache.
// - Beim Öffnen wird sofort die zuletzt gemerkte Version angezeigt (kein Laden).
// - Im Hintergrund wird nur der Datei-Zeitstempel geprüft; der volle Text wird
//   NUR neu geholt, wenn die docx sich geändert hat.
export function useLegalDoc(slug) {
  const cacheKey = `legal_${slug}`;

  const readCache = () => {
    try {
      const c = JSON.parse(localStorage.getItem(cacheKey) || 'null');
      if (c && typeof c.html === 'string') return c;
    } catch { /* ignore */ }
    return null;
  };

  const [state, setState] = useState(() => {
    const c = readCache();
    return c
      ? { html: c.html, available: c.available !== false, loading: false, error: false }
      : { html: null, available: true, loading: true, error: false };
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const cached = readCache();
      try {
        // 1) Billiger Versions-Check (nur Zeitstempel)
        const v = await fetch(`${API}/api/legal/${slug}/version`).then(r => (r.ok ? r.json() : Promise.reject()));
        if (cached && cached.version === v.version) {
          if (!cancelled) setState(s => ({ ...s, loading: false, available: v.available !== false }));
          return; // unverändert -> Cache behalten, nichts neu laden
        }
        // 2) Nur bei Änderung (oder erstem Besuch) den vollen Text holen
        const d = await fetch(`${API}/api/legal/${slug}`).then(r => (r.ok ? r.json() : Promise.reject()));
        if (cancelled) return;
        const entry = { html: d.html || '', version: d.version, available: d.available !== false };
        try { localStorage.setItem(cacheKey, JSON.stringify(entry)); } catch { /* ignore */ }
        setState({ html: entry.html, available: entry.available, loading: false, error: false });
      } catch {
        if (cancelled) return;
        // Fehler/kein Netz: vorhandenen Cache behalten, sonst Fehler zeigen
        setState(s => (cached ? { ...s, loading: false } : { html: null, available: true, loading: false, error: true }));
      }
    })();
    return () => { cancelled = true; };
  }, [slug]); // eslint-disable-line react-hooks/exhaustive-deps

  return state; // { html, available, loading, error }
}
